import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class MatchValidator {
  public static Fields(fieldName: string, matchingFieldName: string, errorToken: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const field = control.get(fieldName);
      const matchingField = control.get(matchingFieldName);

      if (!field || !matchingField) {
        return null;
      }

      if (field.disabled || matchingField.disabled) {
        MatchValidator.clearMismatch(matchingField);

        return null;
      }

      if (matchingField.errors && !matchingField.errors['fieldsMismatch']) {
        return null;
      }

      if (field.value !== matchingField.value) {
        matchingField.setErrors({ ...matchingField.errors, fieldsMismatch: errorToken });

        return { fieldsMismatch: errorToken };
      }

      MatchValidator.clearMismatch(matchingField);

      return null;
    };
  }

  private static clearMismatch(control: AbstractControl): void {
    if (!control.errors?.['fieldsMismatch']) {
      return;
    }

    const errors = { ...control.errors };
    delete errors['fieldsMismatch'];
    control.setErrors(Object.keys(errors).length > 0 ? errors : null);
  }
}
